export default __webpack_public_path__ + "static/media/google-play.6955b1d9.png";